import { combineReducers } from "redux";
import orderReducer from "./orderReducer";
import configurationReducer from "./configurationReducer";
import systemErrorReducer from "./serviceNotificationReducer";
import { localizeReducer } from "react-localize-redux";

const rootReducer = combineReducers({
  orders: orderReducer,
  configuration: configurationReducer,
  localize: localizeReducer,
  notification: systemErrorReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/rootReducer.js